module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-36x36.c07046ce2bfbcaee165bc3ff7e2bb99d.png";